
import { defineComponent, ref, reactive } from "vue";
export default defineComponent({
  props: ["text", "isText"],
  setup(props) {
    return {};
  },
});
